export const WorkFlowAssistant = {
    "Work Flows": {
        items: [
            //Creating a questionnaire template
            {
                heading: 'Creating a system work flow',
                permissions: ['System Admin'],
                tags: ['questionnaire', 'create'],
                sections: [
                    {
                        description: 'Navigate to the systems work flows',
                        styleAs: 'list',
                    },
                    {
                        description: 'Select the <b>create</b> category',
                        styleAs: 'list',
                    },
                    {
                        description: 'Enter a name for the category',
                        styleAs: 'list',
                    },
                    {
                        description: 'A category is a group of work flows to easily orginise work flows',
                        styleAs: 'note',
                    },
                ],
                options: [
                    {
                        option: 'Take me to the system work flows',
                        action: {
                            type: 'location',
                            value: '/sys-admin/patient/events',
                            params: { section: 'main' }
                        },

                    },
                ]
            },
        ]
    }
}